var stringsByLang = {
  da: {
    nav: {
      userGuide: 'Brugerguide',
      apiDocs: 'API Docs',
      signIn: 'Log ind',
      signOut: 'Log ud',
      signedIn: 'Logget ind',
      menuOpen: 'Åbn menu',
      menuClose: 'Luk menu'
    },
    hero: {
      badge: 'Low-code workflow-orkestrering',
      titleLine1: 'Byg, kør og',
      titleAccent: 'reparer workflows',
      titleLine3: 'uden kompleksitet',
      copy: 'Prompt det, kør det, udgiv det — AI-workflows uden teknisk opsætning. AlleFlow giver enkeltpersoner og teams en renere måde at designe workflow-logik, drive AI-agenter, koble OAuth-konti til pr. knude, bygge og redigere workflows i chat med Workflow Copilot og udløse workflows via tidsplan, offentlig URL eller API.',
      ctaPrimary: 'Begynd at bygge',
      // Shown instead of ctaPrimary while WAITLIST_MODE is on.
      ctaPrimaryWaitlist: 'Tilmeld venteliste',
      ctaSecondary: 'Udforsk funktioner',
      trustBadges: []
    },
    marketingLabels: {
      plans: 'Planer',
      answers: 'Svar',
      popular: 'Populær',
      defaultCta: 'Kom i gang'
    },
    comparison: {
      eyebrow: 'Sammenligning',
      title: 'Hvor AlleFlow skiller sig ud',
      headers: {
        feature: 'Funktion',
        traditional: 'Andre workflow-værktøjer',
        alleflow: 'AlleFlow'
      },
      rows: [
        { feature: 'AI-copilot der redigerer canvasset', traditional: 'AI-assistenter genererer et engangs-udkast og overlader resten til dig', alleflow: 'Chat med en copilot der bygger og redigerer det levende canvas — den læser rigtige knude-outputs og anvender ændringer direkte' },
        { feature: 'Workflows funderet i rigtige API-prober', traditional: 'AI-byggere gætter knudekonfigurationer ud fra prompten', alleflow: 'Planneren kører rigtig probe-kode mod dine forbundne tjenester før den planlægger, så genererede workflows bygger på fakta' },
        { feature: 'Redigerbar kode i enhver knude', traditional: 'Kode begrænset til et dedikeret kodetrin — eller ingen indbygget kode overhovedet', alleflow: 'Enhver knude er AI-genereret JavaScript, du kan åbne, læse og redigere direkte' },
        { feature: 'Selvkorrektion under kørsel', traditional: 'Et fejlet trin stopper kørslen, indtil nogen fejlsøger og genstarter', alleflow: 'Autopilot analyserer fejlen, retter knuden og genoptager kørslen — uden manuel indgriben' },
        { feature: 'Automatisering i din egen browser', traditional: 'Cloud-browsere uden adgang til dine loggede sessioner', alleflow: 'Browser Action-knuder styrer din egen Chrome via AlleFlow-udvidelsen — vælg elementer, optag flertrinshandlinger og tag skærmbilleder' },
        { feature: 'Agenter, klassificering og sværme', traditional: 'Én agentknude der kalder værktøjer ét ad gangen', alleflow: 'Dedikerede agent- og klassificeringsknuder plus en sværm af AI-underagenter, der samarbejder om komplekse opgaver' },
        { feature: 'OAuth-konti pr. knude', traditional: 'Én konto pr. integration, eller manuel token-jonglering', alleflow: 'Forbind flere Google/Microsoft/Slack/Atlassian-konti og vælg pr. knude hvilken der bruges' },
        { feature: 'Staging- og Live-versioner', traditional: 'At redigere et workflow betyder at redigere produktion', alleflow: 'Arbejd videre i et udkast mens Live-versionen kører, og publicér når det er klar' },
        { feature: 'Live inspektion af variabler og dataflow', traditional: 'Begrænset indsigt i kørslen, når den først er startet', alleflow: 'Følg variabelværdier og knudeoutput strømme mellem knuderne i realtid under kørslen' },
        { feature: 'Gemmehistorik og genkørsler', traditional: 'Versionering kræver eksternt versionsstyringsværktøj', alleflow: 'Indbygget gemmehistorik med mulighed for genkørsel fra enhver knude' },
        { feature: 'Offentlige fil-output', traditional: 'Eksporter manuelt eller brug ekstern filhosting', alleflow: 'Tokeniserede offentlige URL\'er til genererede filer direkte fra workflowet' },
        { feature: 'Skabeloner og Template Store', traditional: 'Kopiér/indsæt eller begrænset deling af workflows', alleflow: 'Gem knuder som genanvendelige skabeloner og publicér hele workflows i en kurateret Template Store' },
        { feature: 'Programmatisk adgang', traditional: 'Ingen offentlig API eller kun rå webhooks', alleflow: 'API-nøgler, versionerede v1-endpoints og dokumentation indbygget i appen' },
        { feature: 'Playbooks og UI Pages', traditional: 'Workflows ligger flade, og output skal vises i et separat værktøj', alleflow: 'Organisér workflows i playbooks og publicér offentlige UI-sider direkte fra et workflow' }
      ]
    },
    finalCta: {
      eyebrow: 'Kom i gang',
      title: 'Gå fra workflow-idéer til et fungerende system hurtigere.',
      copy: 'Brug byggeværktøjet til visuelt flowdesign, udvid det med AI og tilpasset logik, og hold eksekvering, output og genopretning synligt fra start til slut.',
      ctaPrimary: 'Åbn produkt',
      ctaSecondary: 'Se priser'
    },
    video: {
      eyebrow: 'Se det i aktion',
      title: 'Workflows der bygger, kører og reparerer sig selv',
      copy: 'Fra første prompt til produktionskørsel — se hvordan AlleFlow orkestrerer AI-agenter, tilpasset kode og automatisk selvkorrektion i ét samlet flow.'
    },
autopilot: {
      eyebrow: 'Workflow Copilot',
      title: 'Chat der bygger og redigerer dit levende canvas',
      copy: 'Bed Workflow Copilot om at bygge, ændre eller rette dit workflow. Den læser dine rigtige knude-outputs og canvassets faktiske tilstand og anvender ændringerne direkte, mens du ser på.'
    },
    integrations: {
      titlePrefix: 'Udforsk ',
      titleHighlight: 'ubegrænsede integrationer til næsten enhver tjeneste',
      copy: 'AlleFlow kan integrere de fleste tjenester, dit workflow har brug for. Forbind dem og tilpas hvert trin, præcis som du arbejder.'
    },
    stats: {
      titlePrefix: 'Elsket af kodere og vibecodere ',
      titleHighlight: 'der automatiserer hver eneste dag',
      executionsLabel: 'Workflow-kørsler indtil nu',
      workflowsLabel: 'Workflows oprettet'
    },
    freeTrial: {
      eyebrow: 'Gratis prøve',
      title: 'Prøv AlleFlow gratis'
    },
    footer: {
      apiDocs: 'API Docs',
      privacy: 'Privatlivspolitik',
      terms: 'Servicevilkår'
    },
    waitlist: {
      title: 'Tilmeld dig ventelisten',
      subtitle: 'Vi er i øjeblikket i beta. Udfyld formularen, så giver vi dig adgang, så snart vi kan.',
      emailLabel: 'E-mail',
      emailPlaceholder: 'Indtast din e-mail',
      nameLabel: 'Navn',
      namePlaceholder: 'Dit navn',
      companyLabel: 'Virksomhed',
      companyPlaceholder: 'Din virksomhed',
      jobLabel: 'Din rolle',
      jobPlaceholder: '— Vælg din rolle —',
      reasonLabel: 'Hvad vil du bruge AlleFlow til?',
      reasonPlaceholder: 'Fortæl os kort om dit behov',
      submit: 'Tilmeld mig ventelisten',
      submitting: 'Sender...',
      error: 'Kunne ikke tilmelde dig ventelisten.',
      doneTitle: 'Du er på ventelisten!',
      doneSubtitle: 'Tak fordi du tilmeldte dig. Vi sender dig en e-mail, så snart din adgang er godkendt.',
      backHome: 'Tilbage til forsiden',
      jobs: ['Stifter / CEO', 'Udvikler', 'Marketing', 'Salg', 'Drift', 'Designer', 'Studerende', 'Andet'],
      gateTitle: 'Vi er i beta',
      gateMessage: 'AlleFlow er i øjeblikket i beta. Tilmeld dig ventelisten, så giver vi dig adgang, så snart vi kan.',
      gateConfirm: 'Tilmeld dig ventelisten',
      gateCancel: 'Log ud'
    },
    login: {
      signinTitle: 'Velkommen tilbage',
      signinSubtitle: 'Log ind for at administrere workflows, kørsler og teamautomatiseringer.',
      signupTitle: 'Opret din konto',
      signupSubtitle: 'Opsæt din arbejdsområdeadgang på få sekunder.',
      // {plan} is replaced with the selected plan label (e.g. "Pro").
      signupSubtitlePlan: 'Du har valgt {plan}-planen. Opret din konto for at komme i gang.',
      usernameLabelSignin: 'Brugernavn eller e-mail',
      usernameLabelSignup: 'Brugernavn',
      usernamePlaceholderSignin: 'Indtast dit brugernavn eller din e-mail',
      usernamePlaceholderSignup: 'Vælg et brugernavn',
      emailLabel: 'E-mail',
      emailPlaceholder: 'Indtast din e-mail',
      passwordLabel: 'Adgangskode',
      passwordPlaceholderSignin: 'Indtast din adgangskode',
      passwordPlaceholderSignup: 'Opret en adgangskode',
      forgot: 'Glemt adgangskode?',
      remember: 'Husk mig',
      newsletter: 'Send mig nyheder og produktopdateringer',
      // Forgot-password inline request (signin mode).
      forgotTitle: 'Nulstil din adgangskode',
      forgotSubtitle: 'Indtast din e-mail, så sender vi dig et link til at vælge en ny adgangskode.',
      forgotEmailPlaceholder: 'Indtast din e-mail',
      forgotSubmit: 'Send nulstillingslink',
      forgotSending: 'Sender...',
      forgotSent: 'Hvis der findes en konto med den e-mail, har vi sendt et nulstillingslink. Tjek din indbakke.',
      forgotBack: 'Tilbage til log ind',
      // Reset-password page (/reset-password?token=...).
      resetTitle: 'Vælg en ny adgangskode',
      resetSubtitle: 'Indtast en ny adgangskode til din konto.',
      resetPasswordPlaceholder: 'Ny adgangskode',
      resetConfirmPlaceholder: 'Bekræft ny adgangskode',
      resetSubmit: 'Opdater adgangskode',
      resetSubmitting: 'Opdaterer...',
      resetSuccess: 'Din adgangskode er opdateret. Du kan nu logge ind.',
      resetMismatch: 'Adgangskoderne er ikke ens.',
      resetMissingToken: 'Dette nulstillingslink er ugyldigt eller udløbet.',
      resetGoToLogin: 'Gå til log ind',
      // Terms line split around the two inline links.
      termsBefore: 'Jeg accepterer ',
      termsService: 'servicevilkår',
      termsAnd: ' og ',
      termsPrivacy: 'privatlivspolitik',
      termsRequired: 'Du skal acceptere vilkår og betingelser for at oprette en konto.',
      authFailed: 'Godkendelse mislykkedes.',
      submitting: 'Vent venligst...',
      submitSignup: 'Opret konto',
      submitSignin: 'Log ind',
      or: 'eller',
      switchToSigninPrompt: 'Har du allerede en konto? ',
      switchToSignupPrompt: 'Er du ny? ',
      switchToSignin: 'Log ind',
      switchToSignup: 'Opret en konto'
    }
  },
  en: {
    nav: {
      userGuide: 'User guide',
      apiDocs: 'API docs',
      signIn: 'Sign in',
      signOut: 'Sign out',
      signedIn: 'Signed in',
      menuOpen: 'Open menu',
      menuClose: 'Close menu'
    },
    hero: {
      badge: 'Low-code workflow orchestration',
      titleLine1: 'Build, run and',
      titleAccent: 'repair workflows',
      titleLine3: 'without the complexity',
      copy: 'Prompt it, run it, ship it — AI workflows with no technical setup. Design workflow logic, orchestrate AI agents, and connect your apps per node, then trigger on a schedule, URL, or API.',
      ctaPrimary: 'Start building',
      // Shown instead of ctaPrimary while WAITLIST_MODE is on.
      ctaPrimaryWaitlist: 'Join Waiting List',
      ctaSecondary: 'Explore features',
      trustBadges: []
    },
    marketingLabels: {
      plans: 'Plans',
      answers: 'Answers',
      popular: 'Popular',
      defaultCta: 'Get started'
    },
    comparison: {
      eyebrow: 'Comparison',
      title: 'Where AlleFlow stands out',
      headers: {
        feature: 'Feature',
        traditional: 'Other workflow tools',
        alleflow: 'AlleFlow'
      },
      rows: [
        { feature: 'AI copilot that edits the canvas', traditional: 'AI assistants generate a one-shot draft, then leave you to edit by hand', alleflow: 'Chat with a copilot that builds and edits the live canvas — it reads real node outputs and applies changes in place' },
        { feature: 'Workflows grounded in real API probes', traditional: 'AI builders guess node configurations from the prompt', alleflow: 'The planner runs real probe code against your connected services before planning, so generated workflows are built on facts' },
        { feature: 'Editable code in every node', traditional: 'Code confined to a dedicated code step — or no native code at all', alleflow: 'Every node is AI-generated JavaScript you can open, read and edit directly' },
        { feature: 'Self-correction during runs', traditional: 'A failed step halts the run until someone debugs and restarts it', alleflow: 'Autopilot analyses the error, patches the node and resumes the run — no manual intervention' },
        { feature: 'Automation in your own browser', traditional: 'Cloud browsers with no access to your logged-in sessions', alleflow: 'Browser Action nodes drive your own Chrome via the AlleFlow extension — pick elements, record multi-step actions and capture screenshots' },
        { feature: 'Agents, classifiers and swarms', traditional: 'A single agent node that calls tools one at a time', alleflow: 'Dedicated agent and classifier nodes, plus a swarm of AI sub-agents that collaborate on complex tasks' },
        { feature: 'OAuth accounts per node', traditional: 'One account per integration or manual token juggling', alleflow: 'Connect multiple Google/Microsoft/Slack/Atlassian accounts and pick per node which one to use' },
        { feature: 'Staging and Live versions', traditional: 'Editing a workflow means editing production', alleflow: 'Keep iterating in a draft while the Live version keeps running, then publish when it is ready' },
        { feature: 'Live variable and data-flow inspection', traditional: 'Limited runtime visibility once a run starts', alleflow: 'Watch variable values and node outputs stream between nodes in real time during the run' },
        { feature: 'Save history and reruns', traditional: 'Versioning requires an external version-control tool', alleflow: 'Built-in save history with the option to re-run from any node' },
        { feature: 'Public file output', traditional: 'Export manually or rely on external file hosting', alleflow: 'Tokenised public URLs for generated files straight from the workflow' },
        { feature: 'Templates and Template Store', traditional: 'Copy/paste or restricted workflow sharing', alleflow: 'Save nodes as reusable templates and publish full workflows to a curated Template Store' },
        { feature: 'Programmatic access', traditional: 'No public API or only raw webhooks', alleflow: 'API keys, versioned v1 endpoints and documentation built into the app' },
        { feature: 'Playbooks and UI Pages', traditional: 'Workflows sit flat and output has to live in a separate tool', alleflow: 'Organise workflows into playbooks and publish public UI pages straight from a workflow' }
      ]
    },
    finalCta: {
      eyebrow: 'Get started',
      title: 'Turn workflow ideas into a working system faster.',
      copy: 'Use the builder for visual flow design, extend it with AI and custom logic, and keep execution, output and recovery visible from start to finish.',
      ctaPrimary: 'Open product',
      ctaSecondary: 'See pricing'
    },
    video: {
      eyebrow: 'See it in action',
      title: 'Workflows that build, run and repair themselves',
      copy: 'From the first prompt to a production run — see how AlleFlow orchestrates AI agents, custom code and automatic self-correction in one connected flow.'
    },
autopilot: {
      eyebrow: 'Workflow Copilot',
      title: 'Chat that builds and edits your live canvas',
      copy: 'Ask the Workflow Copilot to build, change or fix your workflow. It reads your real node outputs and the actual state of the canvas, then applies the changes in place while you watch.'
    },
    integrations: {
      titlePrefix: 'Explore ',
      titleHighlight: 'unlimited integrations for nearly any service',
      copy: 'AlleFlow can integrate most services your workflow needs. Connect them and customise each step for exactly how you work.'
    },
    stats: {
      titlePrefix: 'Loved by coders and vibecoders ',
      titleHighlight: 'automating every single day',
      executionsLabel: 'Workflow executions and counting',
      workflowsLabel: 'Workflows created'
    },
    freeTrial: {
      eyebrow: 'Free trial',
      title: 'Try AlleFlow for free'
    },
    footer: {
      apiDocs: 'API docs',
      privacy: 'Privacy policy',
      terms: 'Terms of service'
    },
    waitlist: {
      title: 'Join the waitlist',
      subtitle: 'We\'re currently in beta. Fill out the form and we\'ll give you access as soon as we can.',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      nameLabel: 'Name',
      namePlaceholder: 'Your name',
      companyLabel: 'Company',
      companyPlaceholder: 'Your company',
      jobLabel: 'Your role',
      jobPlaceholder: '— Select your role —',
      reasonLabel: 'What do you want to use AlleFlow for?',
      reasonPlaceholder: 'Tell us briefly about your need',
      submit: 'Join the waitlist',
      submitting: 'Sending...',
      error: 'Could not add you to the waitlist.',
      doneTitle: 'You\'re on the waitlist!',
      doneSubtitle: 'Thanks for signing up. We\'ll email you as soon as your access is approved.',
      backHome: 'Back to home',
      jobs: ['Founder / CEO', 'Developer', 'Marketing', 'Sales', 'Operations', 'Designer', 'Student', 'Other'],
      gateTitle: 'We\'re in beta',
      gateMessage: 'AlleFlow is currently in beta. Join the waitlist and we\'ll give you access as soon as we can.',
      gateConfirm: 'Join the waitlist',
      gateCancel: 'Sign out'
    },
    login: {
      signinTitle: 'Welcome back',
      signinSubtitle: 'Sign in to manage workflows, runs and team automations.',
      signupTitle: 'Create your account',
      signupSubtitle: 'Set up your workspace access in seconds.',
      // {plan} is replaced with the selected plan label (e.g. "Pro").
      signupSubtitlePlan: 'You\'ve selected the {plan} plan. Create your account to get started.',
      usernameLabelSignin: 'Username or email',
      usernameLabelSignup: 'Username',
      usernamePlaceholderSignin: 'Enter your username or email',
      usernamePlaceholderSignup: 'Choose a username',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter your email',
      passwordLabel: 'Password',
      passwordPlaceholderSignin: 'Enter your password',
      passwordPlaceholderSignup: 'Create a password',
      forgot: 'Forgot password?',
      remember: 'Remember me',
      // Forgot-password inline request (signin mode).
      forgotTitle: 'Reset your password',
      forgotSubtitle: 'Enter your email and we’ll send you a link to choose a new password.',
      forgotEmailPlaceholder: 'Enter your email',
      forgotSubmit: 'Send reset link',
      forgotSending: 'Sending...',
      forgotSent: 'If an account exists for that email, we’ve sent a reset link. Check your inbox.',
      forgotBack: 'Back to sign in',
      // Reset-password page (/reset-password?token=...).
      resetTitle: 'Choose a new password',
      resetSubtitle: 'Enter a new password for your account.',
      resetPasswordPlaceholder: 'New password',
      resetConfirmPlaceholder: 'Confirm new password',
      resetSubmit: 'Update password',
      resetSubmitting: 'Updating...',
      resetSuccess: 'Your password has been updated. You can now sign in.',
      resetMismatch: 'Passwords don’t match.',
      resetMissingToken: 'This reset link is invalid or has expired.',
      resetGoToLogin: 'Go to sign in',
      newsletter: 'Send me news and product updates',
      termsBefore: 'I accept the ',
      termsService: 'terms of service',
      termsAnd: ' and ',
      termsPrivacy: 'privacy policy',
      termsRequired: 'You must accept the terms and conditions to create an account.',
      authFailed: 'Authentication failed.',
      submitting: 'Please wait...',
      submitSignup: 'Create account',
      submitSignin: 'Sign in',
      or: 'or',
      switchToSigninPrompt: 'Already have an account? ',
      switchToSignupPrompt: 'New here? ',
      switchToSignin: 'Sign in',
      switchToSignup: 'Create an account'
    }
  }
};

function normaliseLang(lang) {
  if (lang === 'da') return 'da';
  return 'en';
}

function getLandingStrings(lang) {
  return stringsByLang[normaliseLang(lang)];
}

module.exports = {
  getLandingStrings: getLandingStrings
};
